import { buildLocalizedPath } from './localeSlug';
import { resources } from '../locales/resources';

export function buildSEOUrl(baseUrl: string, locale: string, slug?: string | null): string {
  return `${baseUrl}${buildLocalizedPath(slug ?? '', locale as keyof typeof resources)}`;
}

export type LocalizationLike = {
  locale: string;
  slug?: string | null;
};

export function getAlternateLocalizations<T extends LocalizationLike>(
  localizations: T[],
  options?: { requireSlug?: boolean },
): T[] {
  return localizations.filter((loc) => {
    if (!(loc.locale in resources)) return false;
    if (options?.requireSlug && !loc.slug) return false;
    return true;
  });
}
